import React from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { Money } from '../..';
import CornerDownRight from '../../Icons/CornerDownRight';
import Type from './Type';
const Group = (props) => {
    const lang = useSelector((s) => s.lang);
    const voucherTypeProps = {
        caseVouchers: props.caseVouchers,
        category: props.category,
        newCategories: props.newCategories,
        deletable: props.deletable,
        singleCase: props.singleCase,
    };
    const voucherTypes = Object.keys(props.newCategories[props.category].caseVouchers);
    if (voucherTypes.length === 1 && props.collapseGroup)
        return (React.createElement(Type, Object.assign({}, voucherTypeProps, { level: 0, voucherType: voucherTypes[0], caseId: props.caseId, setDepositCaseVoucherHovored: props.setDepositCaseVoucherHovored, depositCaseVoucherHovored: props.depositCaseVoucherHovored })));
    const groupVouchers = props.caseVouchers.filter((caseVoucher) => caseVoucher.category === props.category &&
        caseVoucher.children.length > 0);
    const voucher = groupVouchers[0];
    const children = groupVouchers
        .map((caseVoucher) => caseVoucher.children)
        .reduce((a, e) => a.concat(e), []);
    return (React.createElement(StyledGroup, { parent: groupVouchers.length > 0, small: false },
        React.createElement(GroupHeader, null,
            lang.economyCategories[props.category],
            React.createElement(Money, { color: ['transaction'].indexOf(props.category) != -1, amount: props.newCategories[props.category].sum })),
        voucher && (React.createElement(StyledGroup, { small: true, parent: false, style: { fontSize: '0.8em' } }, Object.entries(children.reduce((acc, child) => {
            acc[child.voucherTypeId] = (acc[child.voucherTypeId] || []).concat(child);
            return acc;
        }, {})).map(([voucherTypeId, children]) => (React.createElement(GroupHeader, { key: voucherTypeId },
            React.createElement("span", null,
                React.createElement(CornerDownRight, { style: {
                        margin: '-0.1em 0.3em 0 0.3em',
                    } }),
                lang.pluralEconomyVoucherTypeLabels[voucherTypeId]),
            React.createElement("div", null,
                React.createElement(Money, { color: ['transaction'].indexOf(props.category) !== -1, amount: children
                        .filter((cv) => cv.deletedAt == null)
                        .reduce((acc, c) => c.amount + acc, 0) }))))))),
        React.createElement(List, null, voucherTypes.map((voucherType) => (React.createElement(Type, Object.assign({}, voucherTypeProps, { level: 1, voucherType: voucherType, caseId: props.caseId, key: voucherType, setDepositCaseVoucherHovored: props.setDepositCaseVoucherHovored, depositCaseVoucherHovored: props.depositCaseVoucherHovored })))))));
};
export default Group;
const StyledGroup = styled.div `
  margin: 0;
  padding: ${(props) => props.small
    ? '0em 0 0.5em 0em'
    : props.parent
        ? '0.5em 0 0.2em 0em'
        : '0.5em 0 0.5em 0em'};
  font-size: ${(props) => (props.small ? '0.8em' : '1em')};
`;
const GroupHeader = styled.div `
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-weight: 900;
`;
const List = styled.div `
  & > div {
    border-bottom: 1px solid #eeeeee;

    &:last-child {
      border-bottom: none;
    }
  }
  /* & > div {
    padding: 3px;

    &:nth-child(odd) {
      background-color: #f5f5f5;
    }

    &:nth-child(even) {
      background-color: #eeeeee;
    }
  } */
`;
//# sourceMappingURL=Group.js.map